(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zakiro-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-zk-chat]');
    if (!trigger) return;
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    event.preventDefault();
    chat.setAttribute('open', '');
  });
  const zkMobile = window.matchMedia('(max-width: 900px)');
  const zkSyncMenus = () => document.querySelectorAll('.zk-navigation').forEach(menu => { menu.open = !zkMobile.matches; });
  zkSyncMenus();
  zkMobile.addEventListener('change', zkSyncMenus);
  document.addEventListener('shopify:section:load', zkSyncMenus);

  } catch(e) { console.error(e); }
})();
})();
